import {
  IconAlertTriangle,
  IconChecks,
  IconHourglass,
} from "@tabler/icons-react"
import { BadgeVariant, StatusBadge } from "@tfg/ui"
import { useMemo } from "react"

import { ExportRequestResponseDtoStatusEnumKey } from "~/gen/api"

export const ExportStatusVariantEnum: {
  [key in ExportRequestResponseDtoStatusEnumKey]: BadgeVariant
} = {
  PENDING: BadgeVariant.WARNING,
  IN_PROGRESS: BadgeVariant.INFO,
  SUCCESS: BadgeVariant.SUCCESS,
  ERROR: BadgeVariant.ERROR,
  FAILED: BadgeVariant.ERROR,
}

export function getStatusVariant(
  status: ExportRequestResponseDtoStatusEnumKey
): BadgeVariant {
  return ExportStatusVariantEnum[status] ?? BadgeVariant.INFO
}

export function ExportStatusBadge({
  status,
}: {
  status: ExportRequestResponseDtoStatusEnumKey
}) {
  const statusIcons = useMemo<{
    [key in ExportRequestResponseDtoStatusEnumKey | "default"]: React.ReactNode
  }>(
    () => ({
      PENDING: <IconHourglass />,
      ERROR: <IconAlertTriangle />,
      FAILED: <IconAlertTriangle />,
      IN_PROGRESS: <IconHourglass />,
      SUCCESS: <IconChecks />,
      default: null,
    }),
    []
  )

  const variant = getStatusVariant(status)

  const icon = useMemo(
    () => statusIcons[status] ?? statusIcons.default,
    [status, statusIcons]
  )

  return <StatusBadge text={status} icon={icon} variant={variant} />
}
